const resellerType = process.env.REACT_APP_RESELLER_TYPE || window.RESELLER_TYPE
window.cypress_resellerType = resellerType

export default {
  reseller: {
    also: resellerType === 'ALSO',
  },
}
